import dayjs from 'dayjs';

export const dateFormat = (date, type = undefined, lang = 'KOR') => {
	// type : 'HHmm' | 'HHmmss'
	if (!date) {
		return '-';
	}

	if (type === 'HHmm') {
		if (lang === 'KOR') {
			return dayjs(date).format('YYYY년 M월 D일 H시 m분');
		}
		return dayjs(date).format('YYYY. MM. DD HH:mm');
	} else if (type === 'HHmmss') {
		return dayjs(date).format('YYYY. MM. DD HH:mm:ss');
	} else {
		if (lang === 'KOR') {
			return dayjs(date).format('YYYY년 M월 D일');
		}
		return dayjs(date).format('YYYY. MM. DD');
	}
};
